const debugLogging = false;

// If you append to this object, you must add to the loadPointsOfInterest() reset as well
var elementsToUpdate = {
    product_price_wrapper: '#product-price',
    hidden_product_select: '#product-select',
    customization_wrappers: '.js-customization-wrapper',
    image_loading_element: '.image-loader',
    product_objects: {
        product: 'div.product[data-product-id]',
        product_options: 'select[data-role="option_selector"]',
        featured_image: '.js-featured-image',
        images_parent_desktop: '.js-thumbs.desktop',
        images_parent_mobile: '.js-thumbs.mobile',
        thumb_image_1: '.js-thumb-image-one',
        thumb_image_2: '.js-thumb-image-two',
        sku_line_item_property: '.js-sku-param',
        image_url_line_item_property: '.js-image-param'
    }
};

const delayAfterLoad = 500;

function main() {
    console.log('%cLoading Objects... Loading Modal Buttons...' , 'color: #bada55' );
    loadPointsOfInterest();
    loadMobileModalCloseButtons();
    return;
}

/**
 * Handles the logic that fires when a new product option is selected
 * @param event - the event object from the js click event
 * @param variants - the variants available on the product
 * @returns void
 */
function handleSelectingNewVariant( event  , variants ) {
    //console.log('handle selecting new variant')
    //Get the proper element clicked based ( if a child node was clicked, loop up dom until at the swatch wrapper )
    let optionClicked = event.target;
    while ( !optionClicked.classList.contains('swatch-wrapper') ) {
        optionClicked = optionClicked.parentElement;
    }

    //Remove the selected class from all the swatches
    let swatchParent = optionClicked.parentElement;
    let childSwatches = swatchParent.querySelectorAll('.swatch-wrapper');
    for ( let swatch of childSwatches ) {
        swatch.classList.remove('selected');
    }

    //Add to the current selected option
    optionClicked.classList.add('selected');
    //console.log("option clicked", optionClicked)

    // store the info that we need to update our swatch to
    const updateInfo = {
        new_swatch: optionClicked.querySelector('.swatch').getAttribute('style'),
        new_text: optionClicked.querySelector('.swatch-label').innerHTML
    };

    // Get the swatch container based on the option clicked
    let swatchContainer = optionClicked;
    while ( !swatchContainer.classList.contains('js-customization-wrapper') ) {
        swatchContainer = swatchContainer.parentElement;
        //console.log("swtach contianer", swatchContainer)
    }

    // Show customization form if custom/com variant option is clicked
    if (swatchContainer && optionClicked) {
        const containerLabel = swatchContainer.querySelector(".utility")
        const containerLabelContent = containerLabel.textContent.toLowerCase()
        const optionLabel = optionClicked.querySelector(".swatch-label")
        const optionLabelContent = optionLabel.textContent.toLowerCase()

        const selectorDisplay = optionClicked.closest(".swatches").previousElementSibling
        const showColorForm = selectorDisplay.hasAttribute("data-show-color-com")
        const showFabricForm = selectorDisplay.hasAttribute("data-show-fabric-com")

        const validLabels = ["color", "fabric", "trim"]

        if (validLabels.includes(containerLabelContent)) {
            const isCustomOrCom = optionLabelContent === "custom" || optionLabelContent === "com"

            if (isCustomOrCom) {
                if (
                    (containerLabelContent === "color" && showColorForm) ||
                    (containerLabelContent === "fabric" && showFabricForm) ||
                    (containerLabelContent === "trim" && showFabricForm)
                ) {
                    showCustomVariationsForm(containerLabelContent)
                }
            } else {
                hideCustomVariationForm(containerLabelContent)
            }
        }
    }

    // Get the swatch container 
    // if this doesnt exists we skip logic
    const swatchToUpdateContainer = swatchContainer.querySelector('.selector-display');
    if ( swatchToUpdateContainer !== null ) {
        const swatchToUpdate = {
            swatch: swatchToUpdateContainer.querySelector('.swatch'),
            text: swatchToUpdateContainer.querySelector('.js-selected-title')
        };
        
        if ( swatchToUpdate.swatch !== null ) {
            swatchToUpdate.swatch.setAttribute( 'style' , updateInfo.new_swatch );
        }

        if ( swatchToUpdate.text !== null ) {
            swatchToUpdate.text.innerHTML = updateInfo.new_text;
        }

        //close the dropdown when the title has open in the classlist
        if ( swatchToUpdate.text.classList.contains( 'open' ) ) {
            swatchToUpdateContainer.click();
        }

        //Get the hidden dropdown and its options
        const relativeOptionSelector = swatchContainer.querySelector('.js-config');
        const relativeOptions = relativeOptionSelector.options;
        
        // Find the matching option with our updateInfo.new_text ( lowercase + handleized )
        let index = 0;
        let selectedValue = '';
        for ( opt of relativeOptions ) {
            let temp = updateInfo.new_text.toLowerCase().replaceAll(' ' , '-' );
            
            //if temp is new-york-blue, translate for dropdown
            if ( temp.includes('new-york-blue') ) {
                temp = temp.replace('new-york-blue' , 'ny-blue');
            }

            const optionValueToLookForAsFloat = parseFloat( temp );
            if ( optionValueToLookForAsFloat > 0 ) {
                temp = temp.replaceAll( '.' , '-' );
            }

            //when found break out of the loop
            if ( opt.value === temp ) {
                selectedValue = temp;
                break;
            }

            //move index forward one
            index++;
        }

        //Clear selection from the hidden dropdown
        for ( let tempOpt of relativeOptions ) {
            tempOpt.removeAttribute('selected');
        }

        if ( selectedValue == '' ) {
            console.warn( 'Selected Value is empty.');
            console.log( 'Did not find: ' , updateInfo.new_text.toLowerCase().replaceAll(' ' , '-' ) );
            console.log( 'Search List: ' , relativeOptions );
        }

        //Set the new option to selected 
        relativeOptionSelector.options.selectedIndex = index;
        relativeOptionSelector.options[relativeOptionSelector.options.selectedIndex].setAttribute('selected' , 'selected');
        
        //Dispatch the change event to trigger the image swap / variant change 
        let tempEvent = new Event('change' , { "bubbles": true, "cancelable": true } )
        relativeOptionSelector.dispatchEvent( tempEvent );

        // Get the variant ID based on temp
        let variantOption = document.querySelector(`option[data-variant-title="${selectedValue}"]`);
        let hiddenIdField = document.querySelector('.js-variant-param');
        let variantId = -1;
        // if the variant option exists
        if ( variantOption != null ) {
            // get the id
            variantId = parseInt( variantOption.value );

            // if the hidden text field exists, update it's value to the selected id
            if ( hiddenIdField != null ) {
                hiddenIdField.value = variantId;
            }

            // loop through the variants and find the correct variant information
            let properVariant = null;
            for ( let variant of variants ) {
                if ( variant.id == variantId ) {
                    properVariant = variant;
                    break;
                }
            }

            // loop through selected variant dropdown for ATC and set new option based on variant Id
            let tIndex = 0;
            let fIndex = 0;
            for ( let option of elementsToUpdate.hidden_product_select.options ) {
                option.removeAttribute('selected');
                let id = parseInt( option.value );
                if ( id === variantId ) {
                    option.setAttribute('selected' , 'selected');
                    fIndex = tIndex;
                }

                tIndex++;
            }

            // Dispatch the change event
            elementsToUpdate.hidden_product_select.options.selectedIndex = fIndex;
            elementsToUpdate.hidden_product_select.dispatchEvent( tempEvent );

            // If the properVariant was found
            if ( properVariant != null ) {
                // If the price wrapper exists
                if ( elementsToUpdate.product_price_wrapper != null ) {
                    var priceFormatted = properVariant.price / 100;
                    var itemPropPrice = priceFormatted;
                    var tradePrice = document.querySelector('.js-trade-discount-price');
                    if ( tradePrice !== null ) {
                        tradePrice = tradePrice.getAttribute('value');
                        tradePrice = parseInt( tradePrice );
                    } else {
                        tradePrice = 0;
                    }
                    var finalTradePrice = priceFormatted - ( tradePrice / 100 );
                    var itemPropTradePrice = finalTradePrice;

                    if ( debugLogging ) {
                        console.log( 'PRICING: ' , itemPropPrice + ' ' + itemPropTradePrice);
                    }

                    var formatNumber = function(num) {
                        return parseFloat(num).toLocaleString('en-US', { 
                            style: 'currency', 
                            currency: 'USD', 
                            maximumFractionDigits: 2, 
                            minimumFractionDigits: 2 
                        });
                    };
                    
                    priceFormatted = formatNumber( priceFormatted );
                    finalTradePrice = formatNumber( finalTradePrice );
                    
                    priceFormatted = `<span itemprop="price" data-justin-100 content="${itemPropPrice}">${priceFormatted}</span>`;

                    finalTradePrice = `<span itemprop="price" content="${itemPropTradePrice}">${finalTradePrice}</span>`;
                
                    var tradePriceEl = elementsToUpdate.product_price_wrapper.querySelector('.js-price-discounted');
                    var retailPriceEl = elementsToUpdate.product_price_wrapper.querySelector('.product-price');

                    // js-price-discounted and product-price exist on the page when logged in
                    // product-price is the only one available when not logged in

                    // if the user is logged in ( both of these need to be present )
                    if ( tradePriceEl !== null && retailPriceEl !== null ) {
                        priceFormatted += '<span> - Retail</span>';
                        finalTradePrice += '<span> - Trade</span>';
                    } 

                    //if retail price exists
                    if ( retailPriceEl !== null ) {
                        retailPriceEl.innerHTML = priceFormatted;
                    }

                    // if trade price exists
                    if ( tradePriceEl !== null ) {
                        tradePriceEl.innerHTML = finalTradePrice;
                    }
                }
            }
        }
    
        if ( debugLogging ) {
            console.log( 'Selected new product option' );
            console.log( 'New Swatch Info: ' , updateInfo );
            console.log( 'Variant Option Found: ' , variantOption );
            console.log( 'Variant Selected Value: ' , selectedValue );
            console.log( 'Swatch Object To Update: ' , swatchToUpdateContainer );
            console.log( 'Swatch Values Updated: ' , swatchToUpdate );
            console.log( 'The hidden dropdown: ' , relativeOptionSelector );
            console.log( 'Options in hidden dropdown:' , relativeOptions );
        }
    }

    return;
}

/**
 * Checks if all required fields within a section are filled
 * @param {HTMLElement} section - The container element that holds required input fields
 * @returns {boolean} - Returns true if all required fields are filled, false otherwise
 */
function areRequiredFieldsFilled(section) {
    const requiredFields = section.querySelectorAll("[required]")

    for (let field of requiredFields) {
        if (field.type === "text" && !field.value) {
            return false
        }

        if (field.type === "radio" && !section.querySelector(`input[name="${field.name}"]:checked`)) {
            return false
        }
    }
    return true
}

/**
 * Adds the required attribute to all inputs in a given container that have the class required-input
 * Attaches event listener to each input so when value changes, the Add to Cart button state is updated
 * @param {HTMLElement} container - The container element holding the input fields.
 */
function addRequiredIfShown(container) {
    const requiredFields = container.querySelectorAll('.required-input');

    function handleChange() {
        handleATCButtonState();
    }

    for (let i = 0; i < requiredFields.length; i++) {
        const field = requiredFields[i];
        field.setAttribute('required', '');
        const eventType = field.type === 'radio' ? 'change' : 'input';
        field.addEventListener(eventType, handleChange);
    }

    handleATCButtonState();
}

function removeRequiredIfHidden(container) {
    const requiredFields = container.querySelectorAll(".required-input")
    for (let i = 0; i < requiredFields.length; i++) {
        const field = requiredFields[i]

        field.removeAttribute("required", "")
    }
}

/**
 * Checks whether all visible required fields in the custom variation form are filled
 * Looks at fabric, color, and trim sections, but only if they are visible
 * Uses areRequiredFieldsFilled() to determine if all required inputs in a section have values
 * If all required fields are filled -  Add to Cart button is enabled
 * If any required fields are missing - Add to Cart button is disabled and adds sold-out class
 */
function handleATCButtonState() {
    const form = document.querySelector(".custom-variation-form")
    const atcButton = document.querySelector(".custom-atc-btn")
    
    if (!form || !atcButton) return

    const fabricContainer = form.querySelector(".fabric-container")
    const colorContainer = form.querySelector(".color-container")
    const trimContainer = form.querySelector(".trim-fabric-container")

    let allFieldsFilled = true;

    if (!fabricContainer.classList.contains("hide") && !areRequiredFieldsFilled(fabricContainer)) {
        allFieldsFilled = false;
    }

    if (!colorContainer.classList.contains("hide") && !areRequiredFieldsFilled(colorContainer)) {
        allFieldsFilled = false;
    }

    if (!trimContainer.classList.contains("hide") && !areRequiredFieldsFilled(trimContainer)) {
        allFieldsFilled = false;
    }

    if (allFieldsFilled) {
        atcButton.classList.remove("sold-out");
        atcButton.removeAttribute("disabled");
    } else {
        atcButton.classList.add("sold-out");
        atcButton.setAttribute("disabled", "disabled");
    }
}

function showCustomVariationsForm(label) {
    //console.log("show form", label)
    const form = document.querySelector(".custom-variation-form")
    const atcButton = document.querySelector(".custom-atc-btn")
    if (form) {
        const colorContainer = form.querySelector(".color-container")
        const fabricContainer = form.querySelector(".fabric-container")
        const trimContainer = form.querySelector(".trim-fabric-container")
        form.classList.remove("hide")

        if (label === "color") {
            colorContainer.classList.remove("hide");

            const comTitle = document.querySelector(".com-title")
            comTitle.textContent = ""
            comTitle.textContent = "Custom Color Requirements:"

            const comDescrip = document.querySelector(".com-description")
            comDescrip.textContent = ""
            comDescrip.textContent = "Please Enter Your Color Information"
            
            addRequiredIfShown(colorContainer)
        } else if (label === "fabric") {
            fabricContainer.classList.remove("hide")
            
            addRequiredIfShown(fabricContainer)
        } else if (label === "trim") {
            trimContainer.classList.remove("hide")
            
            addRequiredIfShown(trimContainer)
        }
    }
}

function hideCustomVariationForm(label) {
    const form = document.querySelector(".custom-variation-form")
    const atcButton = document.querySelector(".custom-atc-btn")
    if (form) {
        const colorContainer = form.querySelector(".color-container")
        const fabricContainer = form.querySelector(".fabric-container")
        const trimContainer = form.querySelector(".trim-fabric-container")

        
        if (label === "color") {
            colorContainer.classList.add("hide")
            removeRequiredIfHidden(colorContainer)
        } else if (label === "fabric") {
            fabricContainer.classList.add("hide")
            removeRequiredIfHidden(fabricContainer)
        } else if (label === "trim") {
            trimContainer.classList.add("hide")
            removeRequiredIfHidden(trimContainer)
        }

        const anyVisible = !colorContainer.classList.contains("hide") ||
                           !fabricContainer.classList.contains("hide") ||
                           !trimContainer.classList.contains("hide")

        if (!anyVisible) {
            form.classList.add("hide")
            if (atcButton) {
                atcButton.classList.remove("sold-out")
                atcButton.removeAttribute("disabled")
            }
        } else {
            handleATCButtonState()
        }
    }
}

/**
 * Handles the logic of updating an image based on the new option selected
 * @param useStaging - a flag set to determine if staging should be used
 * @param apiDomain - the domain of the API to update the image
 * @returns void
 */
function updateProductImage( useStaging = false , apiDomain = '' ) {
    // if useStaging, append &staging=true to url, else append nothing.
    let requestUrl = apiDomain + "/_management/handlers/SingleSKULookup.ashx?legacy=true" + ( useStaging ? "&staging=true" : "" );

    // Not sure what this is for yet. This is a variable that tells the logic to fire a custom image?
    // console.log( window.product );
    // console.log( window.product.hideAppImages );
    
    // show the loading icon
    if ( elementsToUpdate.image_loading_element !== null ) {
        elementsToUpdate.image_loading_element.classList.remove( 'off' );
    }

    // get the currentProductId from our product object
    let currentProductId = 0;
    if ( elementsToUpdate.product_objects.product !== null ) {
        currentProductId = elementsToUpdate.product_objects.product.getAttribute('data-product-id');
    }

    let jsonRequestObject = {
        productId: currentProductId
    };

    // for each option dropdown, get the optionId and the selected option id to send to the API
    for ( let i = 0; i < elementsToUpdate.product_objects.product_options.length; i++ ) {
        let curOption = elementsToUpdate.product_objects.product_options[i];

        let optionId = curOption.getAttribute('data-option-id');
        let optionChecked = curOption.querySelector("option:checked");
        
        if ( optionChecked != null ) {
            jsonRequestObject[ optionId ] = optionChecked.getAttribute('data-value-id');
        }
    }

    if ( debugLogging ) {
        console.log( 'Current Product Id: ' , currentProductId );
        console.log( 'Request Object to send: ' , jsonRequestObject );
    }

    // Make POST request to API 
    var requestToSend = {
        url: requestUrl , 
        type: "POST", 
        data: JSON.stringify( jsonRequestObject ),
        dataType: "json"
    };

    $.ajax( requestToSend ).done( ( response ) => {
        if ( debugLogging ) {
            console.log( 'Response: ' , response );
        }

        // update the sku line item property
        if ( elementsToUpdate.product_objects.sku_line_item_property !== null ) {
            elementsToUpdate.product_objects.sku_line_item_property.setAttribute( 'value' , response.sku );
        }

        // update the image url line item property
        if ( elementsToUpdate.product_objects.image_url_line_item_property !== null ) {
            if ( typeof( response.img ) === 'undefined' ) {
                if ( elementsToUpdate.product_objects.featured_image !== null ) {
                    let collectionUrl = elementsToUpdate.product_objects.featured_image.getAttribute('data-collection');
                    elementsToUpdate.product_objects.image_url_line_item_property.setAttribute( 'value' , collectionUrl );
                }
            } else {
                elementsToUpdate.product_objects.image_url_line_item_property.setAttribute( 'value' , response.img );
            }
        }

        //update the feautured image
        if ( elementsToUpdate.product_objects.featured_image !== null ) {
            if ( typeof( response.img ) === 'undefined' ) {
                let collectionUrl = elementsToUpdate.product_objects.featured_image.getAttribute('data-collection');
                elementsToUpdate.product_objects.featured_image.src = collectionUrl;
            } else {
                elementsToUpdate.product_objects.featured_image.src = response.img;
            }
        }

        // update the first image in the mobile slider
        if ( elementsToUpdate.product_objects.images_parent_mobile !== null ) {
            //get the lifestyle div
            let firstSlide = elementsToUpdate.product_objects.images_parent_mobile.querySelector('.lifestyle');
            //if not null
            if ( firstSlide !== null ) {
                //get the child of the div with the tag img
                firstSlide = firstSlide.querySelector('img');
                // if not null 
                if ( firstSlide !== null ) {
                    // update the image
                    if ( typeof( response.img ) === 'undefined' ) {
                        let collectionUrl = elementsToUpdate.product_objects.featured_image.getAttribute('data-collection');
                        firstSlide.src = collectionUrl;
                    } else {
                        firstSlide.src = response.img;
                    }
                }
            }
        } 

        //remove the loading icon from the image
        if ( elementsToUpdate.image_loading_element !== null ) {
            setTimeout( () => {
                elementsToUpdate.image_loading_element.classList.add( 'off' );
            } , delayAfterLoad );
        }

        if ( debugLogging ) {
            console.log( 'Current State of Elements: ' , elementsToUpdate );
        }

    }).fail( ( response ) => {
        if ( debugLogging ) {
            console.warn( 'Failed to make the POST request: ' , response );
            console.warn( 'Using Shopify default fallback image...' );
        }

        // update the image url line item property
        if ( elementsToUpdate.product_objects.image_url_line_item_property !== null ) {
            if ( elementsToUpdate.product_objects.featured_image !== null ) {
                let collectionUrl = elementsToUpdate.product_objects.featured_image.getAttribute('data-collection');
                elementsToUpdate.product_objects.image_url_line_item_property.setAttribute( 'value' , collectionUrl );
            }
        }

        //update the feautured image
        if ( elementsToUpdate.product_objects.featured_image !== null ) {
            let collectionUrl = elementsToUpdate.product_objects.featured_image.getAttribute('data-collection');
            elementsToUpdate.product_objects.featured_image.src = collectionUrl;
        }

        // update the first image in the mobile slider
        if ( elementsToUpdate.product_objects.images_parent_mobile !== null ) {
            //get the lifestyle div
            let firstSlide = elementsToUpdate.product_objects.images_parent_mobile.querySelector('.lifestyle');
            //if not null
            if ( firstSlide !== null ) {
                //get the child of the div with the tag img
                firstSlide = firstSlide.querySelector('img');
                // if not null 
                if ( firstSlide !== null ) {
                    // update the image
                    let collectionUrl = elementsToUpdate.product_objects.featured_image.getAttribute('data-collection');
                    firstSlide.src = collectionUrl;
                }
            }
        } 

        //remove the loading icon from the image
        if ( elementsToUpdate.image_loading_element !== null ) {
            setTimeout( () => {
                elementsToUpdate.image_loading_element.classList.add( 'off' );
            } , delayAfterLoad );
        }

        if ( debugLogging ) {
            console.log( 'Current State of Elements: ' , elementsToUpdate );
        }
    });

    return;
}

/**
 * Clicks the button with the data attribute data-is-selected-variant when it's set to 'true'
 * @returns void
 */
function clickSelectedButtonOnLoad( ) {
    const buttonsToEmulateClickOnLoad = document.querySelectorAll('[data-is-selected-variant="true"]');

    console.log('%cHandling default variant swap...' , 'color: #bada55' ); 

    if ( debugLogging ) {
        console.log( 'Button to emulate click on load: ' , buttonsToEmulateClickOnLoad );
        console.log( 'Number of Buttons Found - ', document.querySelectorAll('[data-is-selected-variant="true"]').length );
    }
    
    for ( let btn of buttonsToEmulateClickOnLoad ) {
        btn.click();
    }

    return;
}

/**
 * Loads the elementsToUpdate object with the proper elements to reference.
 * @returns void
 */
function loadPointsOfInterest( ) {
    //reset object back to original call
    elementsToUpdate = {
        product_price_wrapper: '#product-price',
        hidden_product_select: '#product-select',
        customization_wrappers: '.js-customization-wrapper',
        image_loading_element: '.image-loader',
        product_objects: {
            product: 'div.product[data-product-id]',
            product_options: 'select[data-role="option_selector"]',
            featured_image: '.js-featured-image',
            images_parent_desktop: '.js-thumbs.desktop',
            images_parent_mobile: '.js-thumbs.mobile',
            thumb_image_1: '.js-thumb-image-one',
            thumb_image_2: '.js-thumb-image-two',
            sku_line_item_property: '.js-sku-param',
            image_url_line_item_property: '.js-image-param'
        }
    };

    // Get General Objects
    elementsToUpdate.customization_wrappers = document.querySelectorAll( elementsToUpdate.customization_wrappers );
    elementsToUpdate.product_price_wrapper = document.querySelector( elementsToUpdate.product_price_wrapper );
    elementsToUpdate.hidden_product_select = document.querySelector( elementsToUpdate.hidden_product_select );
    elementsToUpdate.image_loading_element = document.querySelector( elementsToUpdate.image_loading_element );

    // Get product_objects Objects
    elementsToUpdate.product_objects.product = document.querySelector( elementsToUpdate.product_objects.product );
    elementsToUpdate.product_objects.product_options = document.querySelectorAll( elementsToUpdate.product_objects.product_options );
    elementsToUpdate.product_objects.featured_image = document.querySelector( elementsToUpdate.product_objects.featured_image );
    elementsToUpdate.product_objects.images_parent_desktop = document.querySelector( elementsToUpdate.product_objects.images_parent_desktop );
    elementsToUpdate.product_objects.images_parent_mobile = document.querySelector( elementsToUpdate.product_objects.images_parent_mobile );
    elementsToUpdate.product_objects.thumb_image_1 = document.querySelector( elementsToUpdate.product_objects.thumb_image_1 );
    elementsToUpdate.product_objects.thumb_image_2 = document.querySelector( elementsToUpdate.product_objects.thumb_image_2 );
    elementsToUpdate.product_objects.sku_line_item_property = document.querySelector( elementsToUpdate.product_objects.sku_line_item_property );
    elementsToUpdate.product_objects.image_url_line_item_property = document.querySelector( elementsToUpdate.product_objects.image_url_line_item_property );
    
    if ( debugLogging ) {
        console.log( 'Points of Interest: ' , elementsToUpdate );
    }

    return;
}

/**
 * Loads the event listners for the modal close buttons 
 * @returns void
 */
function loadMobileModalCloseButtons() {
    //js-mobile-select-option
    //close-mobile-selector

    const closeButtons = {
        make_selection_buttons: document.querySelectorAll('.js-mobile-select-option'),
        close_buttons: document.querySelectorAll( '.close-mobile-selector' )
    };

    for ( let btn of closeButtons.make_selection_buttons ) {
        btn.addEventListener('click' , handleMobileModalClose );
    }

    for ( let btn of closeButtons.close_buttons ) {
        btn.addEventListener('click' , handleMobileModalClose );
    }
}

/**
 * Handles the event logic for closing the modals
 * @param event - JS event object 
 * @returns void
 */
function handleMobileModalClose( event ) {
    let swatchParent = event.target;
    
    while ( !swatchParent.classList.contains('swatches') ) {
        swatchParent = swatchParent.parentElement;
    }

    let outerSwatchWrap = swatchParent;
    while ( !outerSwatchWrap.classList.contains('js-customization-wrapper') ) {
        outerSwatchWrap = swatchParent.parentElement;
    }

    swatchParent.classList.remove('open');
    outerSwatchWrap.style.zIndex = 0;

    let title = outerSwatchWrap.querySelector('.js-selected-title');
    if ( title !== null ) {
        title.classList.remove('open');
    }

    document.body.classList.remove('modal-open');
}

document.addEventListener( 'DOMContentLoaded' , main );
window.addEventListener( 'load' , clickSelectedButtonOnLoad )